import { render, staticRenderFns } from "./allocationStorehouseManageList.vue?vue&type=template&id=61e90b47&scoped=true"
import script from "./allocationStorehouseManageList.vue?vue&type=script&lang=js"
export * from "./allocationStorehouseManageList.vue?vue&type=script&lang=js"
import style0 from "./allocationStorehouseManageList.vue?vue&type=style&index=0&id=61e90b47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e90b47",
  null
  
)

export default component.exports